<div id="propertiesPanel" class="propertiesPanel">
  <!-- <ng-container *ngIf="!showProperties">
    <e-form-available-controls></e-form-available-controls>
  </ng-container> -->

  <!-- Tab Properties -->
  <ng-container *ngIf="selectedElementType == 'tab' && selectedTab">
    <div class="propertiesHeader">Tab - {{selectedTab.Name}}</div>
    <!-- Tab Name -->
    <div class="controlProperty">
      <tyl-form-field label='Name' [fullWidth]="true" style="width:100%;">
        <input matInput id='inpTabName' type='text' [(ngModel)]='selectedTab.Name' (ngModelChange)="tabNameChanged()"
          maxlength="25" required />
      </tyl-form-field>
    </div>

    <!-- Conditional Object -->
    <ng-content *ngTemplateOutlet='conditionalObject;context:{object:selectedTab}'></ng-content>
  </ng-container>

  <!-- Page Properties -->
  <ng-container *ngIf="selectedElementType == 'page' && selectedPage">
    <div class="propertiesHeader">Page - {{selectedPage.Name}}</div>
    <!-- Page Name -->
    <div class="controlProperty">
      <tyl-form-field [fullWidth]="true" label='Name'>
        <input matInput id='inpPageName' type='text' [(ngModel)]='selectedPage.Name' />
      </tyl-form-field>
    </div>

    <!-- Conditional Object -->
    <ng-content *ngTemplateOutlet='conditionalObject;context:{object:selectedPage}'></ng-content>
  </ng-container>

  <!-- Column Properties -->
  <ng-container *ngIf="selectedElementType == 'column' && selectedColumn">
    <div class="propertiesHeader">Column</div>
    <tyl-form-field [fullWidth]="true" label='Alignment'>
      <mat-select id='ddlColumnAlignment' [(ngModel)]='selectedColumn.Alignment'>
        <mat-option value='center'>Center</mat-option>
        <mat-option value='flex-start'>Left</mat-option>
        <mat-option value='flex-end'>Right</mat-option>
      </mat-select>
    </tyl-form-field>
    <div class="controlProperty" *ngIf="config.AllowColumnWidth">
      <span>Width</span>
      <tyl-radio-group
        label='Width'
        [(selected)]='selectedColumn.FixedWidth'
        [values]="[false, true]"
        [labels]="['Auto', '']"
        [ids]="['rbColWidthAuto', 'rbColWidthExactly']"
        arrange='vertical'
        [required]='false'
        [contentTemplate]="colWidthRadioTemplate"
        (selectedChange)='colWidthChange()'
        style="padding-left:10px;padding-top: 10px;">
      </tyl-radio-group>
    </div> 
    <div class="controlProperty" *ngIf="config.AllowColumnWidth">
      <tyl-form-field label='Indent' style="width:110px;">
        <input matInput id='inpColumnIndent' name='ColumnIndent' type='text' numbers-only [(ngModel)]='selectedColumn.Indent' />
        <span matSuffix> Pixels</span>
      </tyl-form-field>
    </div> 

  </ng-container>

  <!-- Row Properties -->
  <ng-container *ngIf="selectedElementType == 'row' && selectedRow">
    <div class="propertiesHeader">Row</div>
    <tyl-form-field [fullWidth]="true" label='Alignment'>
      <mat-select id='ddlRowAlignment' [(ngModel)]='selectedRow.Alignment'>
        <mat-option value='flex-end'>Bottom</mat-option>
        <mat-option value='center'>Center</mat-option>
        <mat-option value='flex-start'>Top</mat-option>
      </mat-select>
    </tyl-form-field>
  </ng-container>

  <!-- Control Properties -->
  <ng-container *ngIf="selectedElementType == 'control' && selectedControl">
    <div class="propertiesHeader">Control {{selectedControl.Id}} -
      {{selectedControl.ControlType | formatEFormControlType}}</div>
    <!-- text field value -->
    <div class="controlProperty" *ngIf="selectedControl.ControlType == 'text'">
      <quill-editor #quillDisplayText [style]="{height: '200px', display: 'inline-block'}" [(ngModel)]="selectedControl.Value"
        [readOnly]="selectedControl.TextProvidedOnInstance" name="controlValue" [modules]="quillOptions"
        [required]="!selectedControl.TextProvidedOnInstance">
      </quill-editor>
    </div>
    <!-- Label -->
    <div class="controlProperty"
      *ngIf="selectedControl.ControlType != 'text' && selectedControl.ControlType != 'divider' && selectedControl.ControlType != 'verticalDivider'">
      <tyl-form-field [fullWidth]="true" [postLabelSpace]="true" [label]="selectedControl.ControlType == 'image' ? 'Name' : 'Label'">
        <input matInput #labelInput id='inpControlLabel' type='text' [(ngModel)]='selectedControl.Label'
          (ngModelChange)='labelChanged($event)' (click)="getCaretPosition(labelInput)" (keyup)="getCaretPosition(labelInput)"
          required />
      </tyl-form-field>
    </div>   
    
    <!-- Hint -->
    <div class="controlProperty"
      *ngIf="selectedControl.CustomField && isDevMode && (selectedControl.ControlType == 'dropdown' || selectedControl.ControlType == 'note' || selectedControl.ControlType == 'textbox' || selectedControl.ControlType == 'date' || selectedControl.ControlType == 'time')">
      <tyl-form-field [fullWidth]="true" label="Hint">
        <input matInput #hintInput id='inpControlHint' type='text' [(ngModel)]='selectedControl.HintLabel'/>
      </tyl-form-field>
    </div> 

    <!-- Hide Label -->
    <div class="controlProperty" *ngIf="selectedControl.ControlType != 'text' && selectedControl.ControlType != 'divider' && selectedControl.ControlType != 'verticalDivider' && selectedControl.ControlType != 'image' && selectedControl.ControlType != 'linkToFile' && selectedControl.ControlType != 'component'">
      <tyl-checkbox id='chkHideLabel' name='chkHideLabel' [(checked)]='selectedControl.HideLabel'>
        Hide label on form
      </tyl-checkbox> 
    </div>
    
    <!-- Custom Field Select -->
    <div class="controlProperty" *ngIf="selectedControl.CustomField && selectedControl.ControlType != 'component'">
      <tyl-form-field [fullWidth]="true" label='Select Custom Field'>
        <mat-select id='ddlCustomField' [(ngModel)]='selectedControl.CustomFieldName' (selectionChange)="customFieldSelectChange()" required>
          <mat-option *ngFor='let customField of availableCustomFields' [value]='customField.FieldName'>{{customField.DisplayName}}</mat-option>
        </mat-select>
      </tyl-form-field>
    </div>
    
    <!-- Custom Field Reference -->
    <div class="controlProperty" *ngIf="(selectedControl.CustomField || (config.ViewMode == 'frma' && selectedControl.ControlType == 'component')) && isDevMode && config.ViewMode != 'customPage'">
      <tyl-form-field [fullWidth]="true" [label]="'Reference Name'">
        <input matInput #refNameInput id='inpControlRefNameInput' type='text' [(ngModel)]='selectedControl.CustomFieldRefName' required />
      </tyl-form-field>
    </div>
    
    

    <!-- Can be removed -->
    <div class="controlProperty" *ngIf="(config.ViewMode == 'page' || config.ViewMode == 'frma') && isDevMode">
      <tyl-checkbox id='chkCannotBeRemoved' name='chkCannotBeRemoved' [(checked)]='selectedControl.CannotBeRemoved'>Cannot be removed from page</tyl-checkbox>
    </div>
    
    <!-- Location to save data  -->
    <div class="controlProperty"
      *ngIf="!selectedControl.CustomField && (selectedControl.ControlType == 'buttons' || selectedControl.ControlType == 'dropdown' || selectedControl.ControlType == 'note' || selectedControl.ControlType == 'radioButtons' || selectedControl.ControlType == 'textbox' || selectedControl.ControlType == 'date' || selectedControl.ControlType == 'time')">
      <ng-container *ngIf="!config.IsSurvey && config.AllowSaveToDB">
        <tyl-form-field [fullWidth]="true" label='Location to Save Data' *ngIf="!isCustomFieldsActive">
          <mat-select id='ddlLocationToSave' [(ngModel)]='selectedControl.LinkedDBField'
            (selectionChange)="locationToSaveChange()">
            <mat-option [value]="-1">(e-Form Only)</mat-option>
            <mat-option *ngFor='let dbField of databaseFields' [value]='dbField.ID'>{{dbField.FieldName}}</mat-option>
          </mat-select>
        </tyl-form-field>
        <tyl-form-field [fullWidth]="true" label='Location to Save Data' *ngIf="isCustomFieldsActive">
          <mat-select id='ddlLocationToSave' [(ngModel)]='selectedControl.LinkedCSTFieldName'
            (selectionChange)="locationToSaveCSTChange()">
            <mat-option value="">(e-Form Only)</mat-option>
            <mat-option *ngFor='let dbField of availableCustomFields' [value]='dbField.FieldName'>{{dbField.DisplayName}}</mat-option>
          </mat-select>
        </tyl-form-field>
      </ng-container>
      <!-- Choices -->
          <div style="margin-top: 6px;margin-bottom: 6px;" 
        *ngIf="!selectedControl.CustomField && ((!isCustomFieldsActive && selectedControl.LinkedDBField == -1) || (isCustomFieldsActive && !selectedControl.LinkedCSTFieldName) || showChoicesLink) && (selectedControl.ControlType == 'buttons' || selectedControl.ControlType == 'dropdown' || selectedControl.ControlType == 'radioButtons')">
        <a class="link" (click)="choicesClick()" style="padding-left:0px;"
          [ngStyle]="{'background-color': (((!selectedControl.DropdownOptions.length || !isCodeDescriptionValue) && selectedControl.ControlType != 'radioButtons') || (selectedControl.ControlType == 'radioButtons' && !selectedControl.Value)) ? '#ffff8d' : ''}">
          {{(selectedControl.ControlType == 'radioButtons' && !selectedControl.Value && selectedControl.LinkedDBField != -1) ? "Select Default Choice" : "Choices"}}</a>
      </div>
      <!-- <div style="margin-top: 6px;margin-bottom: 6px;"
        *ngIf="(selectedControl.LinkedDBField == -1 || showChoicesLink) && (selectedControl.ControlType == 'buttons' || selectedControl.ControlType == 'dropdown' || selectedControl.ControlType == 'radioButtons')">
        <a class="link" (click)="choicesClick()" style="padding-left:0px;"
          [ngStyle]="{'background-color': (((!selectedControl.DropdownOptions.length || !isCodeDescriptionValue) && selectedControl.ControlType != 'radioButtons') || (selectedControl.ControlType == 'radioButtons' && !selectedControl.Value && selectedControl.LinkedDBField != -1)) ? '#ffff8d' : ''}">
          {{(selectedControl.ControlType == 'radioButtons' && !selectedControl.Value && selectedControl.LinkedDBField != -1) ? "Select Default Choice" : "Choices"}}</a>
      </div> -->
    </div>
    <div style="display:flex;justify-content: space-between;">
      <!-- Width -->
      <div class="controlProperty" style="width:45%;"
        *ngIf="selectedControl.ControlType == 'textbox' || selectedControl.ControlType == 'note' || selectedControl.ControlType == 'divider' || selectedControl.ControlType == 'dropdown' || selectedControl.ControlType == 'date' || selectedControl.ControlType == 'time'">
        <tyl-form-field [fullWidth]="true" label='Width'>
          <mat-select id='ddlTextboxWidth' [(ngModel)]='selectedControl.Width'>
            <mat-option value='94px'
              *ngIf="selectedControl.ControlType != 'note' && selectedControl.ControlType != 'date' && (selectedControl.ControlType != 'time' || !config.AllowShowTodayButton)">Narrow (1")
            </mat-option>
            <mat-option value='148px'
              *ngIf="selectedControl.ControlType != 'note' && (selectedControl.ControlType != 'date' || !config.AllowShowTodayButton)">Medium - Narrow (1.5")
            </mat-option>
            <mat-option value='196px'>Medium (2")</mat-option>
            <mat-option value='300px'>Medium - Wide (3")</mat-option>
            <mat-option value='400px'>Wide (4")</mat-option>
            <mat-option value='750px'>Extra Wide (7.5")</mat-option>
            <mat-option value='100%' *ngIf="selectedControl.ControlType == 'divider'">Auto</mat-option>
          </mat-select>
        </tyl-form-field>
      </div>
      <!-- Note Rows -->
      <div class="controlProperty" *ngIf="selectedControl.ControlType == 'note'" style="width:45%;">
        <tyl-form-field [fullWidth]="true" label='Height'>
          <input matInput id='inpHeightInRows' type='number' [(ngModel)]='selectedControl.NoteRows' required />
          <span matSuffix>rows</span>
        </tyl-form-field>
      </div>
    </div>
    <!-- Max Length -->
    <!-- <div class="controlProperty" *ngIf="!selectedControl.CustomField && selectedControl.ControlType == 'note'">
      <tyl-form-field label='Character Limit' style="width: 200px;">
        <input matInput id='inpCharacterLimit' type='text' numbers-only [(ngModel)]='selectedControl.MaxLength' />
        <span matSuffix> characters</span>
      </tyl-form-field>
    </div> -->
    <div style="display:flex;align-items:baseline;">
      <!-- Indent -->
      <div class="controlProperty">
        <tyl-form-field [fullWidth]="true" label='Indent' style="max-width:120px;padding-right:10px;">
          <input matInput id='inpIndent' type='number' [(ngModel)]='selectedControl.Indent' />
          <span matSuffix>pixels</span>
        </tyl-form-field>
      </div>
      <!-- Required -->
      <div class="controlProperty"
        *ngIf="selectedControl.ControlType == 'buttons' || selectedControl.ControlType == 'dropdown' || selectedControl.ControlType == 'note' || selectedControl.ControlType == 'radioButtons' || selectedControl.ControlType == 'textbox' || selectedControl.ControlType == 'date' || selectedControl.ControlType == 'checkbox' || selectedControl.ControlType == 'attachment' || selectedControl.ControlType == 'time'">
        <tyl-checkbox id='chkRequired' name='chkRequired' [(checked)]='selectedControl.IsRequired' [disabled]="selectedControl.CustomField && selectedControl.CustomFieldName && isCustomFieldRequired(selectedControl.CustomFieldName)">
          {{selectedControl.ControlType == 'checkbox' ? 'Must be checked by user' : 'Required field'}}
        </tyl-checkbox>
      </div>
      <!-- Choices
        <a class="link" (click)="choicesClick()" style="padding-left:20px;"
            *ngIf="(selectedControl.LinkedDBField == -1 || showChoicesLink) && (selectedControl.ControlType == 'buttons' || selectedControl.ControlType == 'dropdown' || selectedControl.ControlType == 'radioButtons')">Choices</a> -->
    </div>
    <!-- Show Today Button -->
    <div class="controlProperty" *ngIf="config.AllowShowTodayButton && selectedControl.ControlType == 'date'">
      <tyl-checkbox id='chkShowTodayButton' name='chkShowTodayButton' [(checked)]='selectedControl.ShowTodayButton'><span translate>Show Today Button</span></tyl-checkbox>
    </div>
    <!-- Show Now Button -->
    <div class="controlProperty" *ngIf="config.AllowShowTodayButton && selectedControl.ControlType == 'time'">
      <tyl-checkbox id='chkShowNowButton' name='chkShowNowButton' [(checked)]='selectedControl.ShowNowButton'><span translate>Show Now Button</span></tyl-checkbox>
    </div>
    <!-- Height (Dev Only) -->
    <div class="controlProperty" *ngIf="selectedControl.ControlType == 'verticalDivider' && isDevMode">
      <tyl-form-field label='Height' style="max-width:150px;padding-right:10px;">
        <input matInput id='inpDividerHeight' name='DividerHeight' type='text' [(ngModel)]='selectedControl.Height' />
      </tyl-form-field>
    </div>
    <!-- Top Padding (Dev Only) -->
    <div class="controlProperty" *ngIf="selectedControl.ControlType == 'verticalDivider' && isDevMode">
      <tyl-form-field label='Top Padding' style="max-width:150px;padding-right:10px;">
        <input matInput id='inpTopPadding' name='TopPadding' type='text' [(ngModel)]='selectedControl.PaddingTop' />
      </tyl-form-field>
    </div>
    <!-- Remove Bottom Padding -->
    <div class="controlProperty"
    *ngIf="selectedControl.ControlType == 'buttons' || selectedControl.ControlType == 'radioButtons' || selectedControl.ControlType == 'checkbox' || selectedControl.ControlType == 'attachment' || selectedControl.ControlType == 'text' || selectedControl.ControlType == 'image' || selectedControl.ControlType == 'linkToFile' || selectedControl.ControlType == 'divider'">
      <tyl-checkbox id='chkRemovePadding' name='chkRemovePadding' [(checked)]='selectedControl.RemoveBottomPadding'>
        Reduce whitespace below control
      </tyl-checkbox>
    </div>
    <!-- File Upload -->
    <div class="controlProperty"
      *ngIf="(selectedControl.ControlType == 'image' || selectedControl.ControlType == 'linkToFile') && selectedControl.Attachment">
      <add-file [(fileString)]="selectedControl.Attachment.FileDataBase64"
        [(fileName)]="selectedControl.Attachment.OriginalFileName" [checkPNGBitDepth]="true"
        [(fileExtension)]="selectedControl.Attachment.FileExtension" [(fileType)]="selectedControl.Attachment.FileType"
        (fileNameChange)="fileChanged($event)">
      </add-file>
    </div>
    <!-- File Store Location -->
    <div [hidden]="true">
    <div class="controlProperty"  *ngIf="selectedControl.ControlType == 'attachment'">
      <div style="display:flex; flex-direction: column">
        <label>Store Attachment</label>
        <mat-radio-group [name]="'rbgStoreLocation'" (change)="storeLocationChange($event.value)"
          [(ngModel)]="selectedControl.StoreLocation" style="display:flex;flex-direction: column;">
          <mat-radio-button value="eForm" id="rbEFormOnly" style="padding-bottom:10px;"> Only in e-Forms
          </mat-radio-button>
          <mat-radio-button *ngIf="v10" value="student portfolio" id="rbStudentPortfolio">
            <div>Also in Student Portfolio</div>
            <tyl-form-field [fullWidth]="true" label='Category'>
              <mat-select #stuPortCatRef id='ddlStuPortCategory' [(ngModel)]='selectedStuPortCategory'
                [disabled]="selectedControl.StoreLocation != 'student portfolio'"
                (selectionChange)="stuPortCategoryChange()"
                [required]="selectedControl.StoreLocation == 'student portfolio'">
                <mat-option *ngFor='let cat of studentPortfolioCategories' [value]='cat'>{{cat.CodeDescription}}
                </mat-option>
              </mat-select>
            </tyl-form-field>
          </mat-radio-button>
          <mat-radio-button value="student digital content" id="rbStudentDigitalContent">
            <div *ngIf="v10">Also in Student Digital Content</div>
            <div *ngIf="!v10">Also in Student Documents</div>
            <tyl-form-field [fullWidth]="true" label='Document Type'>
              <mat-select #docTypeRef id='ddlStuPortCategory' [(ngModel)]='selectedDocType'
                [disabled]="selectedControl.StoreLocation != 'student digital content'"
                (selectionChange)="docTypeChange()"
                [required]="selectedControl.StoreLocation == 'student digital content'">
                <mat-option *ngFor='let type of documentTypes' [value]='type'>{{type.CodeDescription}}</mat-option>
              </mat-select>
            </tyl-form-field>
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
  </div>
    <!-- Conditional Object -->
    <ng-content *ngTemplateOutlet='conditionalObject;context:{object:selectedControl}'></ng-content>

    <!-- Critical control -->
    <div class="controlProperty" *ngIf="config.IsSurvey && selectedControl.ControlType == 'checkbox'">
      <tyl-checkbox id='chkCriticalControl' name='chkCriticalControl' [(checked)]='selectedControl.IsCritical'>Critical condition if this box is checked</tyl-checkbox>
    </div>

    <!-- Instance specific text option -->
    <div class="controlProperty"
      *ngIf="config.AllowInstanceSpecificText && (selectedControl.ControlType == 'text' || selectedControl.ControlType == 'linkToFile')">
      <tyl-checkbox id='chkTextProvidedOnInstance' name='chkTextProvidedOnInstance'
        [(checked)]='selectedControl.TextProvidedOnInstance' (change)="textProvidedOnInstanceChanged()">
        This {{selectedControl.ControlType == 'text' ? 'text' : 'file'}} will be provided when each e-Form is created
      </tyl-checkbox>
    </div>
    <!-- Instructions text type (plain/rich text) -->
    <div class="controlProperty" *ngIf="config.AllowInstanceSpecificText && selectedControl.ControlType == 'text'">
      <tyl-radio-group [(selected)]="selectedControl.InstructionFormat" [values]="['plainText', 'richText']"
        [labels]="['Plain text', 'Rich text']" [ids]="['rbPlain', 'rbRich']" style='padding-left:10px;'
        [disabled]='!selectedControl.TextProvidedOnInstance'>
      </tyl-radio-group>
    </div>
    <!-- Instructions for instance text -->
    <div class="controlProperty"
      *ngIf="config.AllowInstanceSpecificText && (selectedControl.ControlType == 'text' || selectedControl.ControlType == 'linkToFile')">
      <!-- <quill-editor #quillInstructions [style]="{height: '50px'}" required="selectedControl.TextProvidedOnInstance"
          *ngIf="selectedControl.InstructionFormat == 'plainText' || selectedControl.ControlType == 'linkToFile'" [(ngModel)]="selectedControl.Instructions"
          name="controlInstructions" [modules]="{toolbar: false}">
        </quill-editor>
        <quill-editor #quillInstructions [style]="{height: '200px'}" required="selectedControl.TextProvidedOnInstance"
          *ngIf="selectedControl.InstructionFormat == 'richText' && selectedControl.ControlType != 'linkToFile'" [(ngModel)]="selectedControl.Instructions"
          name="controlInstructions">
        </quill-editor> -->
      <tyl-form-field [fullWidth]="true" label='Instructions' style="width:100%">
        <textarea matInput id='inpInstructions' name='Instructions' type='text'
          [(ngModel)]='selectedControl.Instructions' [disabled]="!selectedControl.TextProvidedOnInstance" rows="4"
          style="resize: none;"></textarea>
      </tyl-form-field>
      <mat-hint>Explain to the user creating the e-Form what they should provide</mat-hint>
    </div>

    <!-- Merge Fields -->
    <!-- <tyl-button image="import.png" label="Display Merge Fields" (clickEvent)="displayMergeFields()"
        *ngIf="selectedControl.ControlType != 'divider' && selectedControl.ControlType != 'image'"></tyl-button> -->


  </ng-container>

</div>

<!-- Conditional Object Template -->
<ng-template #conditionalObject let-object='object'>
    <div class="controlProperty" *ngIf="config.AllowConditionalObjects && (config.ViewMode != 'page' || isDevMode || !object.CannotBeRemoved)">
      <div style="display:flex;align-items: baseline;">
        <div style="width:80px;" *ngIf="config.ViewMode != 'page' || selectedElementType != 'control' || selectedControl.ControlType == 'verticalDivider' || selectedControl.ControlType == 'divider' || selectedControl.ControlType == 'image'">Show only if</div>
        <ng-container *ngIf="config.ViewMode == 'page' && selectedElementType == 'control' && selectedControl.ControlType != 'verticalDivider' && selectedControl.ControlType != 'divider' && selectedControl.ControlType != 'image'">
          <tyl-form-field label='Action' style="width:150px;">

            <mat-select id='ddlConditionalAction' [(ngModel)]='object.ConditionalAction' name='ConditionalAction'>
              <mat-option value='enable'>Enable</mat-option>
              <mat-option value="show">Show</mat-option>
            </mat-select>
          </tyl-form-field>
          <span style="padding-left:5px;">&nbsp;if&nbsp;</span>
        </ng-container>
        <tyl-form-field [fullWidth]="true" label='Parent Control' style="padding-left:10px;flex:1;">
          <mat-select id='ddlParentObject' [(ngModel)]='object.ParentObjectId' (selectionChange)="parentObjectChange()">
            <mat-option value=''></mat-option>
            <mat-option *ngFor='let obj of promptForDataObjects' [value]='obj.Id'>{{obj.Id + ' - ' + obj.Label}}
            </mat-option>
          </mat-select>
        </tyl-form-field>
      </div>
      <div style="display:flex;align-items: baseline;">

        <div style="text-align: right;" [ngStyle]="{'width': config.ViewMode == 'page' && selectedElementType == 'control' && selectedControl.ControlType != 'verticalDivider' && selectedControl.ControlType != 'divider' && selectedControl.ControlType != 'image' ? '170px' : '80px'}">is</div>
        <tyl-form-field [fullWidth]="true" label='Condition' style="padding-left:10px;flex:1;">
          <mat-select id='ddlCondition' [(ngModel)]='object.Condition' [disabled]='!object.ParentObjectId'>
            <mat-option *ngFor='let option of conditions' [value]='option.Code'>{{option.CodeDescription}}</mat-option>
          </mat-select>
        </tyl-form-field>
      </div>
    </div>
</ng-template>


<!-- Column width Radio Template -->
<ng-template #colWidthRadioTemplate let-value="value">
  <div *ngIf="value == true" style="display: flex;">
    <div style="padding-right: 20px; align-items: center; display: flex;">Exactly</div>
    <tyl-form-field label='Width' style="width:120px;padding-top:10px;">
      <input matInput id='inpColWidth' name='ColWidth' type='text' numbers-only [(ngModel)]='selectedColumn.Width' [disabled]="!selectedColumn.FixedWidth" [required]="selectedColumn.FixedWidth"/>
      <span matSuffix> Pixels</span>
    </tyl-form-field>
  </div>
</ng-template>